// /frontend/src/theme.js

import {
	createSystem,
	defaultConfig,
	defineConfig,
	defineRecipe,
	metreaConfig,
} from "@metrea-ui/v2";

const customConfig = defineConfig({
	globalCss: {},
	theme: {
		// Keep app-wide Metrea UI customization here so RAVEN can tune shared
		// component recipes through the system instead of introducing one-off
		// chakra(...) wrappers like the retired RavenButton test helper.
		tokens: {
			colors: {
				brand: { 500: { value: "#2196F3" } },
			},
			fonts: {
				heading: { value: '"HelveticaNeue", Helvetica, sans-serif' },
				body: { value: '"HelveticaNeue", Helvetica, sans-serif' },
			},
		},
		recipes: {
			// Test-only proof recipe. Apply this explicitly in Test.jsx so we can verify
			// RAVEN's theme wiring without changing the app-wide Metrea button recipe.
			ravenTestButton: defineRecipe({
				base: {
					fontWeight: "600",
					borderRadius: "md",
				},
				variants: {
					variant: {
						solid: {
							bg: "brand.500",
							color: "white",
							_hover: {
								bg: "blue.600",
							},
						},
						outline: {
							borderWidth: "1px",
							borderColor: "brand.500",
							color: "brand.500",
							_hover: {
								bg: "blue.50",
							},
						},
					},
				},
			}),
		},
	},
});

export const ravenConfig = customConfig;

export const ravenSystem = createSystem(defaultConfig, metreaConfig, customConfig);
